// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3f9HB","top":"styles_top__3ra8R","left":"styles_left__39YST","description":"styles_description__2Cxtp"};